import {
	Checkbox,
	RadioButton,
	Spinner
} from "@shopify/polaris";
import _ from "lodash";
import * as PropTypes from 'prop-types'
import Select from "react-select";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import withRouter from "helpers/withRouter";
import TopMenuSelectedProjects from './TopMenuSelectedProjects'
import './topbar.css'
import { addProjectOpenNameForUserInfo, switchApp } from '../../redux/features/user/userSlice';
import { isLocalhost, getInitialProject, projectNameToAppId } from '../../utils/appIdStorage';
import { getProjectsForLocalhost, getProjectByName } from '../../projectConfig/projects';
import {
	PROJECT_SWITCH_LANDING_PATH,
	buildProjectSwitchUrl,
} from '../../utils/workspaceSwitch/projectSwitchLanding';

function Typography(props) {
	return null
}

Typography.propTypes = {
	variant: PropTypes.string,
	fontWeight: PropTypes.string,
	children: PropTypes.node
}

const selectedCompany = localStorage?.getItem('selectedCompany');
const selectedProject = getInitialProject();

class TopMenu extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: selectedCompany ? Number(selectedCompany) : props.selected || "",
			filterActive: false,
			filterTrial: false,
			selectedProject: selectedProject,
			switchingProject: false,
		};
	}

	componentDidMount() {
		// Restore selected project from localStorage and dispatch to Redux
		// For localhost: get from app_id, for others: get from selectedProject
		const savedProject = getInitialProject();
		if (savedProject && this.isLocalhost()) {
			this.props.dispatch(addProjectOpenNameForUserInfo(savedProject));
		}
	}

	componentDidUpdate(prevProps) {
		const nextSelected = this.normalizeSelectedCompanyId(this.props.selected);
		const prevSelected = this.normalizeSelectedCompanyId(prevProps.selected);

		if (
			nextSelected &&
			nextSelected !== this.state.selected &&
			nextSelected !== prevSelected
		) {
			this.setState({ selected: nextSelected });
			return;
		}

		if (!prevProps.selected && this.props.selected && !selectedCompany) {
			this.updateSelected();
		}
	}

	normalizeSelectedCompanyId = (value) => {
		const id = Number(value);
		return Number.isFinite(id) && id > 0 ? id : null;
	};

	updateSelected = () => {
		const {selected} = this.props;
		this.setState({
			selected,
		});
	};

	handleSelectChange = (value) => {
		this.setState({selected: value});
	};

	// Check if running on localhost
	// Uses centralized utility function
	isLocalhost = () => {
		return isLocalhost();
	};

	// Handle project selection (radio buttons): same flow as Other Lappa Apps — loader + switchApp
	handleProjectChange = (project) => {
		const projectId = typeof project === 'string' ? project : project?.name;
		const projectObj = typeof project === 'object' && project != null ? project : getProjectByName(projectId);
		const appId = projectObj?.appId ?? projectNameToAppId(projectId) ?? 1;
		const href = projectObj?.href;

		if (this.state.selectedProject === projectId && !this.state.switchingProject) {
			return;
		}

		this.setState({ switchingProject: true });
		this.props.dispatch(switchApp(appId))
			.unwrap()
			.then(() => {
				if (this.isLocalhost()) {
					localStorage.setItem('app_id', appId.toString());
					window.dispatchEvent(new Event('appIdChanged'));
					this.props.dispatch(addProjectOpenNameForUserInfo(projectId));
					this.setState({ selectedProject: projectId, switchingProject: false });
					if (typeof this.props.navigate === 'function') {
						this.props.navigate(PROJECT_SWITCH_LANDING_PATH);
					}
				} else {
					localStorage.setItem('app_id', appId.toString());
					if (href) {
						window.location.href = buildProjectSwitchUrl(href);
					} else {
						this.setState({ selectedProject: projectId, switchingProject: false });
					}
				}
			})
			.catch((err) => {
				this.setState({ switchingProject: false });
				const message = err?.payload || err?.message || 'Failed to switch app. Please try again.';
				alert(message);
			});
	};

	// Render project selector (radio buttons) - ONLY for localhost
	renderProjectSelector = () => {
		// CRITICAL: Only show radio buttons on localhost
		if (!this.isLocalhost()) {
			return null;
		}

		const availableProjects = getProjectsForLocalhost(isLocalhost);
		const { selectedProject } = this.state;

		if (availableProjects.length === 0) {
			return null;
		}

		return (
			<div>
				<div
					style={{
						padding: '10px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-around'
					}}
				>
					{availableProjects.map((project) => (
						<div key={project.name} style={{ marginRight: 10 }}>
							<RadioButton
								label={project.displayName}
								checked={selectedProject === project.name}
								id={project.name}
								name="project"
								onChange={() => this.handleProjectChange(project)}
							/>
						</div>
					))}
				</div>
			</div>
		);
	};

	render() {
		const {
			title,
			loadingButtonClick,
			manager
		} = this.props;
		const {
			selected,
			filterActive,
			filterTrial,
			selectedProject
		} = this.state;
		let options = [];
		if (this.props.options) {
			let filteredOptions = [...this.props.options];
			if (filterActive && filterTrial) {
				filteredOptions = _.filter(
						filteredOptions,
						(item) => item.status === "active" || item.status === "trial"
				);
			} else if (filterActive) {
				filteredOptions = _.filter(
						filteredOptions,
						(item) => item.status === "active"
				);
			} else if (filterTrial) {
				filteredOptions = _.filter(
						filteredOptions,
						(item) => item.status === "trial"
				);
			} else {
				filteredOptions = filteredOptions;
			}
			options = filteredOptions.map((company) => {
				return {
					label: company.name,
					value: company.id,
				};
			});
		}

		const menuOptions = [
			{
				label: "",
				value: "",
			},
			...options,
		];

		const { switchingProject } = this.state;
		return (
				<div
						style={{
							padding: "10px 0",
							backgroundColor: "#ffffff",
							boxShadow: '0px 2px 5px 0px rgba(67, 105, 139, 0.1)'

						}}
				>
					{switchingProject && (
						<div
							style={{
								position: 'fixed',
								top: 0,
								left: 0,
								right: 0,
								bottom: 0,
								backgroundColor: 'grey',
								zIndex: 99999,
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center',
								gap: 16,
							}}
						>
							<div className="topbar-switching-spinner_white">
								<Spinner accessibilityLabel="Switching app" size="large" />
							</div>
							<span style={{ color: '#fff', fontSize: 16 }}>Switching app...</span>
						</div>
					)}
					<div
							className='Polaris-Page'
							style={{
								width: '100%',
								maxWidth: '100%'
							}}
					>
						<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									width: '100%'
								}}
						>
							{
								manager
										?
										<div
												style={{
													display: 'flex',
													justifyContent: 'space-around',
													alignItems: 'center'
												}}
										>
											<p
													style={{
														marginRight: 10,
														fontSize: '14px',
														fontWeight: 'bold'
													}}
											>
												{title}
											</p >
											<div
													style={{
														display: 'flex',
														alignItems: 'center'
													}}
											>
												<div style={{marginRight: 10}}>
													<Checkbox
															label='Active'
															checked={filterActive}
															onChange={() =>
																	this.setState((prevState) => ({
																		filterActive: !prevState.filterActive,
																		selected: "",
																	}))
															}
													/>
												</div >
												<div style={{marginRight: 10}}>
													<Checkbox
															label='Trial'
															checked={filterTrial}
															onChange={() =>
																	this.setState((prevState) => ({
																		filterTrial: !prevState.filterTrial,
																		selected: "",
																	}))
															}
													/>
												</div >
											</div >
											<div
													style={{
														display: 'flex',
														justifyContent: 'flex-end',
														alignItems: 'center'
													}}
											>
												<div style={{minWidth: "150px"}}>
													<Select
															id='companyId'
															value={
																	menuOptions?.find(({value}) => value === selected) || ""
															}
															onChange={({value}) => {
																this.setState({selected: value});
																this.props.changeCompanyName(value)
																localStorage.setItem('selectedCompany', JSON.stringify(value));
															}}
															options={menuOptions}
															isLoading={loadingButtonClick}
															styles={{
																menu: (provided) => ({
																	...provided,
																	zIndex: 9999
																}),
																indicatorSeparator: () => ({display: "none"}),
																dropdownIndicator: () => ({display: "none"})
															}}
															caretDown={null}
													/>
												</div >
											</div >
										</div >
										:
										<div ></div >
							}

							{/* Project selection for localhost - dynamically rendered from config */}
							{this.renderProjectSelector()}

							<TopMenuSelectedProjects />
						</div >
					</div >
				</div >
		);
	}
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
	dispatch
});

export default withTranslation()(
		connect(mapStateToProps, mapDispatchToProps)(withRouter(TopMenu))
);
